/**
 * 活动状态管理
 */
import axios from "axios";
export default {
  namespaced: true,
  state: {
    id: null,
    liveTitle: "",
    liveTypeCode: "",
    creator: {},
    languageObj:{},
    uid:null,
    iCloudUserId:"",
    pcBackUrl: "",
    wxShareUrl: "",
    phoneBackUrl: "",
    qrCodeUrl:"",
    isGamePlaying: false,
    isLotteryPlaying: false,
    playingGameId: null,
    drawingId: null,
    signBackUrl: "",
    liveConfig:null,
    wxLiveList: [],
    goldThreshold: 0,
    goldLotterySwitch: false,
    gameYue:0
  },
  mutations: {
    setLiveId(state, val) {
      state.id = val;
    },
    initLive(state, obj) {
      state.id = obj.id;
      state.uid = obj.uid;
      state.liveConfig = obj.liveConfig;
      state.iCloudUserId = obj.iCloudUserId;
      state.creator = obj.creator;
      state.liveTitle = obj.liveTitle;
      state.liveTypeCode = obj.liveTypeCode;
      state.pcBackUrl = obj.pcBackUrl;
      state.signBackUrl = obj.signBackUrl;
      state.phoneBackUrl = obj.phoneBackUrl;
      state.qrCodeUrl = obj.qrCodeUrl;
      state.wxShareUrl = obj.wxShareUrl;
      state.isLotteryPlaying = obj.isLotteryPlaying;
      state.drawingId = obj.drawingId;
      state.isGamePlaying = obj.isGamePlaying;
      state.playingGameId = obj.playingGameId;
      state.wxLiveList = obj.wxLiveList;
      state.goldThreshold = obj.goldThreshold;
      state.goldLotterySwitch = obj.goldLotterySwitch;
      state.gameYue = obj.gameYue;
      state.isOpenWishLive = obj.isOpenWishLive;
    },
    setLanguageObj(state, languageObj) {
      state.languageObj = languageObj;
    },
    showGameReady(state, msg) {
      const json = JSON.parse(msg.data);
      state.isGamePlaying = true;
      state.playingGameId = json.liveGameId;
    },
    openGameReady(state, liveGameId) {
      state.isGamePlaying = true;
      state.playingGameId = liveGameId;
    },
    openLotteryReady(state, drawingId) {
      state.isLotteryPlaying = true;
      state.drawingId = drawingId;
    },
    initGoldenEggDraw(state,drawingId){
      state.drawingId = drawingId;
    },
    showLotteryReady(state, obj) {
      state.isLotteryPlaying = true;
      state.drawingId = obj.id;
    },
    closeGameReady(state) {
      state.isGamePlaying = false;
      state.playingGameId = null;
    },
    closeLottery(state) {
      state.isLotteryPlaying = false;
      state.drawingId = null;
    },
  },
  actions: {
    getLiveInfo({ commit }, liveId) {
      return new Promise((resolve, reject) => {
        axios
          .get("/live/getLiveInfo", { params: { id: liveId } })
          .then((res) => {
            commit("initLive", res.data);
            resolve(res.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getLanguageItems({ commit }, liveId) {
      return new Promise((resolve, reject) => {
        axios
            .get("/live/getLiveLanguageItems", { params: { liveId } })
            .then((res) => {
              // commit("initLive", res.data);
              const languageItems = res.data;
              const languageObj = {};
              languageItems.forEach(item => {
                languageObj[item.translationKey] = item.translationValue;
              });
              commit("setLanguageObj", languageObj);
              resolve(languageObj);
            })
            .catch((e) => {
              reject(e);
            });
      });
    },
    /**
     * 拉取完整 live 信息（用于游戏准备阶段补充 drawingId 等）
     * 金蛋游戏(game.id=6) 进入时调用，从返回里取 drawingId 写入 state
     */
    fetchLive({ commit }, liveId) {
      return new Promise((resolve, reject) => {
        axios
          .get("/live/fetchLive", { params: { id: liveId } })
          .then((res) => {
            const liveInfo = res.data || {};
            // 拿到 drawingId 后写入，供金蛋页用
            if (liveInfo.drawingId) {
              commit("initGoldenEggDraw", liveInfo.drawingId);
            }
            resolve(liveInfo);
          })
          .catch((e) => {
            reject(e);
          });
      });
    }
  },
};
